import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: null,
};

const tokenSlice = createSlice({
  name: "token",
  initialState,
  reducers: {
    setTokenInStore: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setTokenInStore } = tokenSlice.actions;

export default tokenSlice.reducer;
